export default "__VITE_ASSET__8354b255__"